// @flow

import * as React from 'react'

type Props = {
  src?: string,
  pauseWhenOffScreen?: Boolean,
  width?: number,
  height?: number,
  poster?: string,
  className?: string,
}

export const Video = ({
  src,
  pauseWhenOffScreen = true,
  poster,
  className,
  ...props
}: Props) => {
  const videoRef = React.useRef<?HTMLVideoElement>()

  React.useEffect(() => {
    if (!pauseWhenOffScreen) return

    const observer = new IntersectionObserver(
      ([{ isIntersecting }]) => {
        if (isIntersecting) videoRef.current?.play()
        else {
          videoRef.current?.pause()
        }
      },
      {
        threshold: 0.1,
      }
    )

    if (videoRef.current) observer.observe(videoRef.current)

    return () => {
      observer.disconnect()
    }
  }, [videoRef, pauseWhenOffScreen])

  return (
    <video
      src={src}
      muted
      autoPlay={!pauseWhenOffScreen}
      loop
      ref={videoRef}
      poster={poster}
      {...props}
      className={className}
    >
      <source src={src} type="video/mp4" />
      <p>Your browser doesn't support HTML5 video.</p>
    </video>
  )
}
